import { specProgReqActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [specProgReqActions.loadSuccess]: (state, action) => {
        return action.payload.entities.specProgReqMsgDetails;
    },
    [specProgReqActions.replySuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if (x.mgsxno === action.payload) {
                delete state[x.nono];
            }
        })
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        let result;
        result = action.payload.specProgReqMsgs.entities.specProgReqMsgDetails ? action.payload.specProgReqMsgs.entities.specProgReqMsgDetails : {};
        return result;
    }

})


